function initPageContentLinkEvents() {
    const onClick = function( event: Event ) {
        if ( !event.target || !( event.target instanceof HTMLAnchorElement ) ) {
            return;
        }

        const el = event.target;

        const hasHref = el.hasAttribute( 'href' );

        if ( !hasHref && !el.dataset.altHref ) {
            return;
        }

        const isLocationAnchor = el.matches( '[data-action="page-content-link"]' );
        const isContentLink = el.matches( '.location-info a' );

        if ( !isLocationAnchor && !isContentLink ) {
            return;
        }
    };

    document.addEventListener( 'click', onClick, false );
}

export default initPageContentLinkEvents;
